import { BCMSRecord, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormRowView, PageContainer, PageContentView, WidgetContainer, WidgetView } from 'components/shared';
import InfoAlertView from "components/shared/views/InfoAlertView";
import Classes from "model";
import React from 'react';
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayExceptionsPage
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Exceptions page.
 */
export default function TASPositivePayExceptionsPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(undefined, context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

  });

  return (
    <PageContainer className="tas-positive-pay-exceptions-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}

export const getDefaultData = () => {
    
};

export const getDefaultUI = () => ({
  accountSelect: { isActive: false }
});

function PageContent(props) {
  const { data, ui } = useStateManager();

  return (
    <PageContentView>
         <WidgetContainer className="tas-positive-pay-exceptions-widget">
            <WidgetView text="Exceptions">
                <div className="flex-container flex-horizontal past-review-cutoff-time-container">
                    <div className="set-width curfew-alert">
                      <InfoAlertView text="You are past the review cutoff time. No decisions can be made."/>
                    </div>
                </div>
                <div className="flex-container flex-horizontal account-selection-container">
                    <div className="set-width custom-select-account-container">
                      <FormRowView text="Account">
                        <CustomSelect value="All" active={ ui.accountSelect.isActive }>
                            <CustomSelectItem value="All">All</CustomSelectItem>
                        </CustomSelect>
                      </FormRowView>
                    </div>
                    <div className="flex-width review-cutoff-time-container">
                      <InfoAlertView text="Review cutoff time: 09:30 AM"/>
                    </div>
                </div>
                <div className="flex-width text-center">{ `No exception is available.` }</div>
            </WidgetView>
        </WidgetContainer>
    </PageContentView>
  );
}